export const cars =[
    {
        image: "/images/Renault logan/1.jpg",
        // title: "Logan"
    },
    {
        image: "/images/Renault logan/1.webp",
        // title: "Logan"
    },
    {
        image: "/images/Renault logan/2.webp",
        // title: "Logan"
    },
    {
        image: "/images/Renault logan/3.webp",
        // title: "Logan"
    },
    {
        image: "/images/Renault logan/4.webp",
        // title: "Logan"
    }
];